var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4084 94.9205L24.1316 101.619L0 22.866L82.8684 0L107 78.7533L58.4573 92.1477V107.001H48.4084V94.9205ZM48.4084 84.9537L30.9253 89.7827L12.455 29.3896L76.004 11.8365L94.4742 72.2297L58.4573 82.178V62.6812H48.4084V84.9537ZM46.1438 50.8446C46.1438 46.944 49.3284 43.9176 53.4329 43.9176C57.4666 43.9176 60.6511 46.944 60.7219 50.8446C60.7219 54.7453 57.5373 57.7717 53.4329 57.7717C49.3284 57.7717 46.1438 54.7453 46.1438 50.8446Z",
    fill: "#E7F0FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeUnion);
export default __webpack_public_path__ + "static/media/Badge_union.2d29f836b1444fe7cf63f57223eee984.svg";
export { ForwardRef as ReactComponent };